module.exports = __webpack_public_path__ + "media/images/ir/profile/photo_fujimura-a3efe6c592320bd5d7c7285298289986.jpg";